import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RouteType } from 'types/map';

interface RoutesPayload extends Omit<PayloadAction, 'payload'> {
  payload: { routes: RouteType[] };
}

interface RoutePayload extends Omit<PayloadAction, 'payload'> {
  payload: { route: RouteType };
}

const initialValue: RouteType[] = [];

export const routesSlice = createSlice({
  name: 'routes',
  initialState: {
    value: initialValue,
  },
  reducers: {
    add: (state, action: RoutePayload) => {
      const { route } = action.payload;
      state.value = [
        ...state.value,
        {
          id: route.id,
          name: route.name,
          distance: route.distance,
          duration: {
            hours: route.duration.hours,
            minutes: route.duration.minutes,
          },
          color: route.color,
          routes: route.routes,
          segments: route.segments,
        },
      ];
    },
    change: (state, action: RoutePayload) => {
      const { route } = action.payload;
      state.value = state.value.map((r) => {
        if (r.id === route.id) {
          return route;
        } else {
          return r;
        }
      });
    },
    remove: (state, action: { payload: { id: string } }) => {
      const { id } = action.payload;
      state.value = state.value.filter((r) => r.id !== id);
    },
    replace: (state, action: RoutesPayload) => {
      state.value = action.payload.routes;
    },
  },
});

// Action creators are generated for each case reducer function
export const { add, change, remove, replace } = routesSlice.actions;
export const selectAllRoutes = (state) => state.routes;

export default routesSlice.reducer;
